/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterItem.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/AttributeModel.js" />

var ProductModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.Description = ko.observable();
    that.DisplayName = ko.observable();
    that.VideoLink = ko.observable();
    that.ArticleReference = ko.observable();
    that.Attributes = ko.observableArray([]);
    that.Extensions = ko.observableArray([]);
    
    that.CustomFormatLengthMin = ko.observable();
    that.CustomFormatLengthMax = ko.observable();
    that.CustomFormatWidthMin = ko.observable();
    that.CustomFormatWidthMax = ko.observable();

    that.SelectedAttributeAndExtensionValues = ko.observableArray([]);

    that.SelectedAttribute = "";
    that.SelectedValue = "";
    that.SelectedExtensionId = -1;

    //flags
    that.LastSelectedObjectValue = ko.observable(-1);
    that.IsProductModelValid = ko.observable(false);
    that.IsProductModelRePopulating = ko.observable(false);
    that.IsExtension = ko.observable(false);
    that.ValidateModel = ko.observable(true);
    that.IsLoading = ko.observable(false);
    that.IsDependencyLoading = ko.computed(function() {
        return pageModelHndl.pTopProductModel.IsLoading();
    }, this, { pure: true });

    //functions
    that.SetSelectetExtension = function (extensionId) {
        that.SelectedExtensionId = extensionId;
        return true;
    };

    that.IsAttributesAndExtensionsValid = function () {
        var valid = true;

        //check if all attributes are valid
        for (var i = 0; i < that.Attributes().length; i++) {
            var attr = that.Attributes()[i];
            if (!attr.IsValid()) {
                valid = false;
            }
        }

        // check if all ext are valid
        for (var e = 0; e < that.Extensions().length; e++) {
            var ext = that.Extensions()[e];

            for (var k = 0; k < ext.Attributes().length; k++) {
                if (!ext.Attributes()[k].IsValid()) {
                    valid = false;
                }
            }
        }

        return valid;
    };

    that.UpdateBeginnerMode = function () {
        if (!pageModelHndl.pProductModel.IsProductModelRePopulating()) {
            pageModelHndl.IsBeginnerModeReady(false);
            $.each(that.Attributes(), function (i, attr) {
                pageModelHndl.pProductModel.IsProductModelRePopulating(true);
                attr.UpdateForBeginnerMode();

                if (i == (that.Attributes()).length - 1) {
                    pageModelHndl.IsBeginnerModeReady(true);
                    pageModelHndl.pProductModel.IsProductModelRePopulating(false);
                }
            });
        }

        $.each(that.Extensions(), function (i, ext) {
            var extDomSelect = $("#js_beginnerExtensionObjectValuesDiv_" + ext.ExtensionId() + " select");

            $.each(ext.Attributes(), function (j, attr) {
                attr.UpdateForBeginnerMode();
                $.each(attr.ObjectValues(), function (k, objValue) {

                    if (objValue.HasError() || !objValue.IsEnabled()) {
                        $((extDomSelect[i]).options[k + 1]).removeClass().addClass("invisibleSelectedValue");
                    }
                    else {
                        $((extDomSelect[i]).options[k + 1]).removeClass().addClass("baseSelectedValue");
                    }
                });
            });
        });
    };

    that.PopulateProductModel = function (productData) {
        that.Description("<h3>" + productData.Description + "</h3><p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p><p>Aenean commodo ligula eget dolor. Aenean massa.</p><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,</p>"); //(productData.Description);
        that.DisplayName(productData.DisplayName);
        that.VideoLink(productData.VideoLink);
        that.PopulateAttributes(productData.Attributes, productData.Extensions);
        pageModelHndl.TeaserPanel(productData.TeaserPanel);
        pageModelHndl.AdditionalTeaserPanel(productData.AdditionalTeaserPanel);

        if(userSettings.isProductOverviewBs4Enabled) {
            // only required for bs4 layout
            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            })
        }
    };

    var updateProductConfiguration = function() {
        var productConfigurationFilterModel = new ProductConfigurationFilterModel(pageModelHndl);    
        var data = ko.mapping.toJSON(productConfigurationFilterModel);
        console.log("updateProductConfiguration sending ", JSON.parse(data));

        var url = $("#FilterSelectionUrl").val();
        pageModelHndl.pProductModel.IsLoading(true);
        return $.ajax({
            url: url,
            type: "POST",
            data: data,
            dataType: "json",
            contentType: "application/json; charset=utf-8"
        }).fail(function () {
            alerts.error();
        }).always(function () {
            pageModelHndl.pProductModel.IsLoading(false);
        });
    };

    that.UpdateProductModel = function () {
        if (!that.ValidateModel()) {
            return;
        }
        if (that.IsProductModelRePopulating()) {
            return;
        }
        if (pageModelHndl.IsCatalogueProduct()) {
            that.IsProductModelValid(true);
            if (that.IsProductModelValid()) {
                pageModelHndl.pPriceTableModelV2.UpdatePricetableDataByArticleReference(that.ArticleReference(),
                    pageModelHndl.CurrentAmount());
            }

            if (!pageModelHndl.IsAdGalleryInitialized()) {
                $(document).trigger("loadAdGallery");
                pageModelHndl.IsAdGalleryInitialized(true);
            }
        } else {
            updateProductConfiguration().done(function(data) {
                that.UpdateAttributes(data.Model.EnabledValueIds,
                    data.Model.Extensions,
                    data.Model.LastSelectedIds,
                    data.Model.CustomFormatMinMax);

                if (that.IsProductModelValid()) {
                    pageModelHndl.pPriceTableModelV2.UpdatePriceTableData(pageModelHndl.CurrentAmount());
                }

                if (!pageModelHndl.IsAdGalleryInitialized()) {
                    $(document).trigger("loadAdGallery");
                    pageModelHndl.IsAdGalleryInitialized(true);
                }

                try {
                    // only required for bs4 layout
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip()
                    })
                }
                catch(e) {
                    // do nothing
                }
            });
        }
    };

    that.PopulateExtensions = function (extensionsData) {
        that.Extensions([]);

        if (extensionsData != null && extensionsData.length > 0) {
            $.each(extensionsData, function (i, ext) {
                var extModel = new ExtensionModel(pageModelHndl);
                extModel.ExtensionId(ext.ExtensionId);
                extModel.Object_ObjectExtensionId(ext.Object_ObjectExtensionId);
                extModel.LocalizationKey(ext.LocalizationKey);

                $.each(ext.Attributes, function (j, attr) {
                    var attrModel = new AttributeModel(pageModelHndl, extModel);
                    attrModel.PopulateAttributeModel(attr);

                    extModel.Attributes.push(attrModel);
                });

                that.Extensions.push(extModel);

                if (i === (extensionsData.length - 1)) {
                    populateDefaultObjectValue(that.Attributes());
                    populateDefaultObjectValue(extModel.Attributes());
                    pageModelHndl.IsBeginnerModeReady(true);
                    pageModelHndl.IsProductModelPopulated(true);
                    if(that.SelectedAttributeAndExtensionValues().length > 0) {
                        that.UpdateProductModel();
                    }
                }
            });
        }
        else {
            populateDefaultObjectValue(that.Attributes());
            pageModelHndl.IsBeginnerModeReady(true);
            pageModelHndl.IsProductModelPopulated(true);
            if(that.SelectedAttributeAndExtensionValues().length > 0) {
                that.UpdateProductModel();
            }
        }
    };
    
    var populateDefaultObjectValue = function(attributeModels) {
        $.each(attributeModels, function(j, attrModel){
            attrModel.PopulateDefaultObjectValue();
        });
    }

    that.PopulateAttributes = function (attributesData, extensionsData) {
        that.Attributes([]);

        $.each(attributesData, function (i, attr) {
            var attributeModel = new AttributeModel(pageModelHndl, that);
            attributeModel.PopulateAttributeModel(attr);
            that.Attributes.push(attributeModel);

            if (i === (attributesData.length - 1)) {
                that.PopulateExtensions(extensionsData);
            }
        });

        var galleryAttributes = that.Attributes().filter(function (element) {
            return element.AttributeId() == pageModelHndl.ImageSliderAttributeId();
        });

        if (galleryAttributes.length > 0) {
            var attribute = galleryAttributes[0];
            if (!attribute.SelectedObjectValueId()) {
                var objectValues = attribute.ObjectValues();
                if (objectValues.length > 0) {
                    attribute.SelectedObjectValueId(objectValues[0].ObjectValueId());
                }
            }

        }
    };

    that.UpdateAttributes = function (selectableValueIds, extensions, lastSelectedIds, customFormatMinMax) {
        var flag = true;

        var attributes = that.Attributes();
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];

            attr.UpdateAttributeModel(selectableValueIds, false);

            if(attr.CustomFormat.IsCustomFormatOptionAvailable() && customFormatMinMax !== null) {
                that.CustomFormatLengthMax(customFormatMinMax.MaxLength);
                that.CustomFormatLengthMin(customFormatMinMax.MinLength);
                that.CustomFormatWidthMax(customFormatMinMax.MaxWidth);
                that.CustomFormatWidthMin(customFormatMinMax.MinWidth);
                attr.CustomFormat.UpdateMinAndMax(that);
            }
            
            if (!attr.IsValid()) {
                flag = false;
            }
        }

        var hasExtension = extensions.length > 0;
        if (hasExtension) {

            for (var j = 0; j < extensions.length; j++) {

                var ext = extensions[j];

                var isEnabled = !((that.Extensions())[j]).IsDisabled();
                if (isEnabled) {

                    var extensionAttributes = ((that.Extensions())[j]).Attributes();
                    for (var k = 0; k < extensionAttributes.length; k++) {

                        var extensionAttribute = extensionAttributes[k];

                        extensionAttribute.UpdateAttributeModel(ext.SelectedExtensionObjectValueIds, true);
                        if (!extensionAttribute.IsValid()) {
                            flag = false;
                        }
                    }

                }
            }
        }

        that.IsProductModelValid(flag);
        if (!pageModelHndl.IsCatalogueProduct()) {
            that.UpdateBeginnerMode();
        }
        $(document).trigger('gridLayoutIeApply');
    };

    that.RePopulateProductModel = function (selectedValues) {
        that.RePopulateAttributesAndExtensions(selectedValues);
    };

    that.RePopulateAttributesAndExtensions = function (selectedValues) {
        that.IsProductModelRePopulating(true);

        function updateAttributes(attributes, selectedAttributeValues) {

            for (var i = 0; i < attributes.length; i++) {
                var attribute = attributes[i];

                var selectedValue = selectedAttributeValues.filter(function (item) {
                    return item.AttributeId === attribute.AttributeId();
                })[0];

                if (selectedValue) {
                    attribute.SelectedObjectValueId(selectedValue.ObjectValueId);
                    attribute.InnerLastSelected(selectedValue.ObjectValueId);
                    attribute.CustomValue.IsCustomValueOptionSelected(selectedValue.IsCustomValue);
                    attribute.CustomValue.CustomValue(selectedValue.CustomValue);
                    if(selectedValue.IsCustomFormat) {
                        attribute.CustomFormat.IsCustomFormatSelected(true);
                        attribute.CustomFormat.Length(selectedValue.CustomLength);
                        attribute.CustomFormat.Width(selectedValue.CustomWidth);
                    }
                } else {
                    console.info("updating attributes: attribute ", attribute.AttributeId(), " not selected, isExtension ", attribute.IsExtension());
                }
            }

        }

        if (pageModelHndl.IsCatalogueProduct()) {
            that.IsProductModelRePopulating(false);
            return;
        }

        // update content
        var selectedContentValues = selectedValues
            .filter(function (item) { return !item.IsExtension; });

        var attributes = that.Attributes();
        updateAttributes(attributes, selectedContentValues);

        // update extensions
        var selectedExtensionValues = selectedValues
            .filter(function (item) { return item.IsExtension; });

        for (var l = 0; l < that.Extensions().length; l++) {
            var extension = that.Extensions()[l];

            attributes = extension.Attributes();
            updateAttributes(attributes, selectedExtensionValues);
        }

        // set last selected item
        var lastSelectedItem = selectedValues[selectedContentValues.length - 1];
        that.LastSelectedObjectValue(lastSelectedItem.ObjectValueId);

        that.IsProductModelRePopulating(false);
    };
};
